// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_1h-1";
export var movingGradient = "_1h-4";
export var movingGradientBlock = "_1h-2";
export var skeleton = "_1h-0";
export var skeletonText = "_1h-3";